import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ProfileOptionsWrapper from "../Dashboard/ProfileOptions/ProfileOptionsWrapper";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";

import "./topbar.scss";
import { CartPreview } from "../Dashboard/ShoppingCart/CartPreview";

const TopBar = (props) => {
  const { t, i18n } = useTranslation();
  return (
    <>
      <nav id="topbar">
        <div className="topbarMenu">
          <div className="topbarLink">
            <Link className="edustiy-logo" to="/">
              <img
                src="https://cdn.edusity.com/edusity-logo.svg"
                alt="Edusity Logo"
              />
            </Link>
          </div>

          <div className="topbarLogin">
            {props.loggedIn && (
              <div className="right-menu">
                <CartPreview />
                <ProfileOptionsWrapper link="dashboard" label="Dashboard" />
              </div>
            )}
          </div>
        </div>
      </nav>
    </>
  );
};

function mapStateToProps(state) {
  const { loggedIn } = state.authentication;
  return {
    loggedIn,
  };
}

const connectedTopBar = connect(mapStateToProps)(TopBar);
export default connectedTopBar;
